import { toast } from "sonner";

// Registers the service worker and surfaces "new version" updates without trapping the user on an old build.
export function registerSW() {
  if (!("serviceWorker" in navigator) || process.env.NODE_ENV !== "production") return;
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");
      const promptUpdate = (worker) => {
        toast("Nova versão disponível.", {
          id: "sw-update", duration: Infinity,
          action: { label: "Atualizar", onClick: () => worker.postMessage("SKIP_WAITING") },
        });
      };
      if (reg.waiting && navigator.serviceWorker.controller) promptUpdate(reg.waiting);
      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        nw?.addEventListener("statechange", () => {
          if (nw.state === "installed" && navigator.serviceWorker.controller) promptUpdate(nw);
        });
      });
      let refreshing = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => { if (!refreshing) { refreshing = true; window.location.reload(); } });
      const check = () => reg.update().catch(() => {});
      setInterval(check, 60 * 60 * 1000);
      document.addEventListener("visibilitychange", () => document.visibilityState === "visible" && check());
    } catch (e) { /* SW is optional */ }
  });
}

export function clearSWCaches() {
  if ("serviceWorker" in navigator) navigator.serviceWorker.controller?.postMessage("CLEAR_CACHE");
}
